export default "__VITE_ASSET__DtY8yVn3__"